// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sales-control .hotdamnbar{margin:20px 0 0}", "",{"version":3,"sources":["webpack://./client/modules/structure/sales/salesControl/salesControl.css"],"names":[],"mappings":"AACC,2BACC,eACD","sourcesContent":[".sales-control {\n\t.hotdamnbar {\n\t\tmargin: 20px 0 0px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
